import { render } from "./employees-list.vue?vue&type=template&id=535576dc&scoped=true"
import script from "./employees-list.vue?vue&type=script&lang=js"
export * from "./employees-list.vue?vue&type=script&lang=js"

import "./employees-list.vue?vue&type=style&index=0&id=535576dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535576dc"]])

export default __exports__